enum SnackBarMessages {
  NONE = '',
  LOGINSUCCESS = 'You have logged in successfully!',
  UNAUTHORIZED = 'You are not an authorized person,Please Contact Admin for more details',
  COMMONERROR = 'Oops Something went wrong',
  SCHEDULED_CALL = 'Call has been scheduled with Bharat Carbon'
}

export default SnackBarMessages;
